import { FormGroup, Button, Label, Form } from '../../components/Bootstrap';
import * as React from 'react';

const Logo = require('./Logo.svg');

interface MFAFormProps {
  login({ mfaCode }: { mfaCode: string });
  error?: Error;
  loading: boolean;
}

const inputChangeEventToText = (setFn) => {
  return (e) => {
    setFn(e.target.value);
  };
};

export const MFAForm = ({ login, loading, error }: MFAFormProps) => {
  const [mfaCode, setMFACodeFromEvent] = React.useState<string>('');
  const setMFACode = inputChangeEventToText(setMFACodeFromEvent);

  const onSubmit = React.useCallback(
    async (event) => {
      event.preventDefault();
      login({ mfaCode });
    },
    [mfaCode, login]
  );

  return (
    <Form onSubmit={onSubmit} method='post'>
      <img src={Logo} alt='Noble' className='login-card-logo' />
      <p className='text-center'>{error && error.message}</p>
      <FormGroup>
        <Label for='MFA Code'>MFA Code</Label>
        <input
          name='username'
          id='username'
          onChange={setMFACode}
          className='login-input form-control'
          value={mfaCode}
        />
      </FormGroup>
      <div className='text-center'>
        <Button color='primary' type='submit' disabled={loading} className='btn--rounded ps-4 pe-4'>
          Sign In
        </Button>
      </div>
    </Form>
  );
};
